import type { TFunction } from 'i18next'

const OAUTH_INTERRUPTED_CODES = new Set([
  'pkce_verifier_missing',
  'missing_code',
  'google_oauth_start_failed',
  'linkedin_oauth_start_failed',
  'auth0_oauth_start_failed',
])

const SESSION_EXPIRED_CODES = new Set(['session_missing', 'user_not_found'])

export function resolveAuthLoginError(code: string, t: TFunction): string {
  const normalized = code.trim()

  if (OAUTH_INTERRUPTED_CODES.has(normalized)) {
    return t('login.errors.oauthInterrupted')
  }

  if (normalized === 'session_exchange_failed') {
    return t('login.errors.sessionFailed')
  }

  if (SESSION_EXPIRED_CODES.has(normalized)) {
    return t('login.errors.sessionExpired')
  }

  if (normalized === 'registration_failed') {
    return t('login.errors.registrationFailed')
  }

  if (normalized === 'professional_email_required') {
    return t('login.errors.professionalEmailRequired')
  }

  if (normalized === 'auth0_domain_not_allowed') {
    return t('login.errors.auth0DomainNotAllowed')
  }

  if (normalized === 'sso_required') {
    return t('login.errors.ssoRequired')
  }

  if (normalized === 'freelancer_invitation_required') {
    return t('login.errors.freelancerInvitationRequired')
  }

  if (normalized === 'Link expired') {
    return t('auth.callback.linkExpired')
  }

  return t('login.errors.generic')
}
